/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@express-labs/raven-ui';
import s from './BagIcon.module.scss';

function BagIcon({ bagCount, ...otherProps }) {
  return (
    <button type="button" className={s.bagIconButton} {...otherProps} aria-label="shopping bag">
      {bagCount > 0 && <span className={s.numberOfItems}>{bagCount}</span>}
      <Icon icon="shoppingBag" />
    </button>
  );
}

BagIcon.propTypes = {
  bagCount: PropTypes.string,
};

export default BagIcon;
